import { Icon } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import React, { FunctionComponent } from 'react'
import {
  DECIMAL_PLACES,
  useFormatPercentage,
} from '../../helpers/formatNumberHooks'

type Props = {
  /** LSPay cash discount rate, as a percentage (e.g. `4` for 4%). */
  rate: number
}

/**
 * Banner shown above the payment input when the active outlet has an LSPay
 * cash discount configured. Mirrors the look & feel of `CashDiscountingBanner`.
 */
export const LspCashDiscountingBanner: FunctionComponent<Props> = ({
  rate,
}) => {
  const formatPercentage = useFormatPercentage({
    minimumFractionDigits: DECIMAL_PLACES,
  })

  return (
    // Can't use helios <Banner> because it justifies all the text to the centre
    <div className="wr-lsp-cash-discounting-banner vd-banner vd-banner--info">
      <div className="vd-banner-wrapper vd-flex vd-flex--justify-between">
        <span>
          <Icon icon="fa-info-circle" className="vd-banner-icon"></Icon>
          <T
            _str="Cash discount {rate} will apply if paid in cash."
            _context="LSPay cash discounting banner"
            rate={formatPercentage(rate / 100)}
          />
        </span>
      </div>
    </div>
  )
}
